import type { ReactNode } from "react";
import { Bot } from "lucide-react";
import { cn } from "@/lib/utils";
import { McpOfferLink, type McpOfferPlacement } from "./mcp-offer-link";

/**
 * One quiet line that offers the MCP server where the data already is: under an
 * app's figures, under a chart's title. It imports no server code, so the app
 * page's client tree can render it too.
 */
export function McpOfferStrip({
  placement,
  children,
  className,
}: {
  placement: McpOfferPlacement;
  children: ReactNode;
  className?: string;
}) {
  return (
    <p data-mcp-cta={placement} className={cn("text-[13px] text-muted-foreground", className)}>
      <McpOfferLink
        placement={placement}
        className="inline-block rounded-sm pl-5 -indent-5 outline-none transition-colors hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring"
      >
        <Bot className="mr-1.5 inline-block h-3.5 w-3.5 -translate-y-px align-middle" aria-hidden="true" />
        {children}{" "}
        <span className="whitespace-nowrap font-medium text-foreground">Connect your AI agent →</span>
      </McpOfferLink>
    </p>
  );
}
